<template>
    <div v-if="dataSource" class="p-relative">

        <Toolbar                         
            v-on:toolbar-button-click="onToolbarClick"  
        > 
            <!--Панель поиска-->
            <SearchPanel
                v-model="search"
                :has-filter="false"
            />
        </Toolbar>
       
        <FilterPanel
            v-if="filterDataSource"
            :dataSource="filterDataSource"
            v-bind:status.sync="collection"
            v-bind:substatus.sync="status"
        >
        </FilterPanel>
        
        <component
            :is="collection"
            :status="status"
            :search="search"
            ref="currentComponent"
        />

    </div>
</template>

<script>
import _ from 'lodash';
import { mapActions } from 'vuex';
import { httpAPI } from "@/api/httpAPI";

import Toolbar from '@/components/documents/Toolbar.vue';
import SearchPanel from '@/components/documents/SearchPanel.vue';
import FilterPanel from '@/components/documents/FilterPanel.vue';
import ExtendedFilterPanel from '@/components/documents/ExtendedFilterPanel.vue';

import MyExecutionTask from './task-lists/MyExecutionTask.vue';
import MyCreatedTask from './task-lists/MyCreatedTask.vue';

export default {
    name: 'QalaQyzmetTasks',
    components: {
        FilterPanel,
        SearchPanel,
        ExtendedFilterPanel,
        Toolbar,
        MyExecutionTask,
        MyCreatedTask
    },
    data () {
        return {
            dataSource: null,
            filterDataSource: null
        }
    },
    computed: {
        collection: {
            get: function() {
                return this.$store.getters['qalaQyzmet/tasks/getCollection'];
            },
            set: function(newValue) {
                this.$store.commit('qalaQyzmet/tasks/SET_COLLECTION', newValue);
            }
        },
        status: {
            get: function() {
                return this.$store.getters['qalaQyzmet/tasks/getStatus'];
            },
            set: function(newValue) {
                if (typeof this.$refs.currentComponent?.resetPage === "function") 
                    this.$refs.currentComponent.resetPage();

                if (newValue)
                    this.$store.commit('qalaQyzmet/tasks/PUSH_STATUS', newValue);
            }
        },
        search: {
            get: function() {
                return this.$store.getters['qalaQyzmet/tasks/getSearch'];
            },
            set: _.debounce(function(v) {
                if (typeof this.$refs.currentComponent?.resetPage === "function")
                    this.$refs.currentComponent.resetPage();

                this.$store.commit('qalaQyzmet/tasks/PUSH_SEARCH', v );
            }, 500)
        }
    },
    methods: {
        ...mapActions(['setOverlayVisible']),
        onToolbarClick(event, btn) {
            let method = this[btn.Action];

            if (method)
                method(btn);
            else
                this.$notify.alert(`Действие ${btn.Action} не реализовано`);
        },
        async loadButtons() {
            this.setOverlayVisible({ visible: true });

            let response = await httpAPI({
                url: `api/actions/collection?type=Orders.Order`,
                method: 'GET'
            });

            if (response) {
                await this.loadFilters();
                this.dataSource = response.data.Payload;
                this.$store.commit('documents/toolbar/SET_MENU', { menu: this.dataSource.Data.Menu });
            }
            
            this.setOverlayVisible({ visible: false });
        },
        async loadFilters() {
            let filterResponse = await httpAPI({
                url: `/api/tasks/filter?collection=${this.collection}`,
                method: 'GET'
            });

            if (filterResponse) {
                let permissions = (this.$store.getters['global/auth/getUserInfo'])?.Permissions ?? [];

                filterResponse.data.Payload.Filter.Items = 
                    filterResponse.data.Payload.Filter.Items
                        .filter(i => i.Value != 'MyControlTask')
                        .filter(i => i.Requires.length === 0 || this.$_.intersection(i.Requires, permissions).length > 0);

                this.filterDataSource = filterResponse.data.Payload;
            }
        },
        async Refresh() {
            await this.loadFilters();
            this.$refs.currentComponent.getData(true);
        },
        async Export() {
            let filter = this.$refs.currentComponent.getTableFilterObject();
            delete filter.Limit;
            delete filter.Offset;
            filter.collection = this.collection;
            let exportURI = `api/download/export?param=${JSON.stringify(filter)}`;
            this.$eventBus.$emit('on-get-report', {url: exportURI, text: this.$t('Экспорт_списка_нарядов_от_date.message', { date: this.$moment().format('DD.MM.YYYY HH.mm.ss') }), type: 'Xls' });
        }
    },
    watch: {
        collection: function(newValue, oldValue) {
            if (oldValue != null)
                this.loadButtons();
        }
    },
    async created() {
        await this.loadButtons();
    }
}
</script>
